// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"f98d142b","211":"22b70346","480":"741ffbb4","488":"a795b591","746":"27aef8cf","929":"ce164dc6","992":"09350fc6"}[chunkId] + ".chunk.js";
};